// Configuration for payment and application URLs
export const PAYMENT_BASE_URL = import.meta.env.VITE_PAYMENT_BASE_URL;
export const APP_BASE_URL = import.meta.env.VITE_BASE_URL;

// Function to determine the correct base URL for payments
const getPaymentBaseUrl = (): string => {
  // For localhost development, use localhost instead of the production payment domain
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return window.location.origin;
  }
  return PAYMENT_BASE_URL || 'https://billpa.id';
};

// Function to generate payment URLs
export const getPaymentUrl = (productId: string): string => {
  return `${getPaymentBaseUrl()}/${productId}`;
};

// Function to generate offer page URLs
export const getOfferUrl = (offerId: string): string => {
  return `${getPaymentBaseUrl()}/bundle/${offerId}`;
};

// Function to generate subscription preview URLs
export const getSubscriptionPreviewUrl = (subscriptionId: string): string => {
  return `${APP_BASE_URL}/subscription-preview?id=${subscriptionId}`;
};

// For backward compatibility - redirects from old URLs
export const getOldPaymentUrl = (productId: string): string => {
  return `/pay/${productId}`;
};
